/**
 * Entity Action Map
 * Maps each entity to its action definition function
 * Provides a single place to see which entities have which actions
 */

import type { EntityActionMapType, ActionsForEntity } from "../types/registry";
import type { EntityKey } from "../types/entity-keys";

/**
 * Lazy-loaded action definitions
 * Each entity's actions are imported only when needed
 */
export const entityActionMap: Partial<EntityActionMapType> = {
  // These will be populated in Phase 2 and 3
  // For now, we define the structure
};

/**
 * Register an entity's actions in the map
 * Used during initialization
 */
export function registerEntityActions<K extends EntityKey>(
  entity: K,
  actionsFn: () => ActionsForEntity<K>
): void {
  (entityActionMap as any)[entity] = actionsFn;
}

/**
 * Get the action definition function for an entity
 */
export function getEntityActionsFn<K extends EntityKey>(
  entity: K
): (() => ActionsForEntity<K>) | undefined {
  return (entityActionMap as any)[entity];
}

/**
 * List all registered entities
 */
export function getRegisteredEntities(): EntityKey[] {
  return Object.keys(entityActionMap) as EntityKey[];
}
